import { Helpers } from '../../helpers';
import { IAssetStatus } from '../../interfaces/iasset-status';
import { Asset } from '../asset';

export class AssetStatusBase {
  AssetStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Assets_AssetStatus?: Array<Asset> | null;

  constructor(item?: IAssetStatus) {
    if (item) {

      this.AssetStatusId = item.AssetStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Assets_AssetStatus = Helpers.createClassArray(Asset, item.Assets_AssetStatus);
    }
  }
}